import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TenantService } from '@org/shared-services';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-admin',
    imports: [CommonModule, ReactiveFormsModule],
    templateUrl: './admin.component.html',
    styleUrl: './admin.component.css'
})
export class AdminComponent {
  tenantForm: FormGroup;

  constructor(private tenantService: TenantService, private fb: FormBuilder, private snackBar: MatSnackBar) {

    this.tenantForm = this.fb.group({
      tenantName: ['', [Validators.required]],
      contactEmail: ['', [Validators.required, Validators.email]],
      tenantPhone: ['', [Validators.required]],
      website: [''],
      logoUrl: [''],
      address: this.fb.group({
        line1: [''],
        line2: [''],
        city: [''],
        state: [''],
        zipCode: [''],
        country: ['USA']
      }),
      type: ['', [Validators.required]],
      parentTenant: ['Gerber Collision Corporation'],
      adminName: ['', [Validators.required]],
      adminEmail: ['', [Validators.required, Validators.email]],
      adminRole: [[], [Validators.required]],
      isVerified: [false],
    });
  }

  onSubmit() {
    if (this.tenantForm.valid) {
     // console.log(this.tenantForm.valid);
      this.tenantService.createTenant(this.tenantForm.value)
        .subscribe({
          next: (response) => {
            const msg = 'Tenant created successfully';
            this.snackBar.open(msg, 'Close', {
              duration: 5000,
            });
          },
            error: (error) => {
              const msg = `Error creating tenant: ${error}`;
              this.snackBar.open(msg, 'Close', {
                duration: 5000,
              });
          },
          complete: () => {

          }
        });
    } else {
      
    }
  }
}
